export default function Testimonials() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-5 gap-8 bg-gray-900 rounded-3xl overflow-hidden shadow-2xl">
          <div className="md:col-span-2 relative">
            <div className="w-full h-full min-h-96">
              <img
                src="https://public.readdy.ai/ai/img_res/703957f9313172c08a88ec3659a6455f.jpg"
                alt="Client Testimonial"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="md:col-span-3 p-12 flex flex-col justify-center">
            <div className="text-6xl text-teal-400 mb-6 font-serif">"</div>
            <p className="text-xl text-white leading-relaxed mb-8">
              Working with this team has been transformative for our business. They helped us enter three new markets in just six months, and their marketing expertise drove a 200% increase in qualified leads. Their strategic approach and deep market knowledge made all the difference.
            </p>
            <div className="mb-6">
              <h4 className="text-xl font-bold text-white mb-1">Sarah Mitchell</h4>
              <p className="text-gray-400">CEO, TechVision Solutions</p>
            </div>
            <button className="self-start px-6 py-3 bg-gradient-to-r from-teal-500 to-emerald-500 text-white font-medium rounded-full hover:shadow-lg transition-all cursor-pointer whitespace-nowrap">
              Read More Success Stories
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
